import React from 'react';
import ActivityIndicator from '../../ActivityIndicator.js';
import ModalContent from './ModalContent.js';
const ModalPredefinedLoading = () => /*#__PURE__*/React.createElement(ModalContent, {
  type: "loading"
}, /*#__PURE__*/React.createElement(ActivityIndicator, {
  busy: ActivityIndicator.busyStates.busy
}));
export default ModalPredefinedLoading;